/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { ChildrenWrapper, Container, Content, LogoFull, LogoMini, MenuToggle, Dropdown, DropdownItem, DropdownMenu } from "./styles";
import LogoMiniSource from "../../assets/images/sweep-pro-mini.png";
import LogoFullSource from "../../assets/images/sweep-pro-full-light.png";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "../../store";
import { systemMenuToggle } from "../../store/system/slice";
import Icon from "../../assets/Icon";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { startChangePassword } from "../../store/authentication/slice";

const Header: React.FC = ({ children }) => {
    const menuOpen = useSelector((state: IApplicationState) => state.system.menuOpen);

    const authenticatedUSer = useSelector((state: IApplicationState) => state.authentication.user);

    const dispatch = useDispatch();

    const { t } = useTranslation();


    return <Container>
        <Content>
            <MenuToggle onClick={() => {
                dispatch(systemMenuToggle(!menuOpen))
            }}>
                <Icon size={24} icon={'menu'} color={'#fff'} />
            </MenuToggle>
            <LogoMini src={LogoMiniSource} alt={'Infinity Safe'} />
            <LogoFull src={LogoFullSource} alt={'Infinity Safe'} />
            <ChildrenWrapper>
            {children}
            </ChildrenWrapper>
            <Dropdown>
                <DropdownItem>
                {!authenticatedUSer?.error && <>{authenticatedUSer?.name} <Icon icon={'arrow-down'} color={'#fff'} size={20} /></>} 
                {authenticatedUSer?.error && <><Icon icon={'warning'} color={'#fff'} size={20} /> {authenticatedUSer?.error.message}</>} 
                    <DropdownMenu>
                        <li onClick={() => dispatch(startChangePassword())}> 
                            <a>{t("menu.reset_password")}</a>
                        </li>
                        <li>
                            <NavLink
                                onClick={() => {
                                    dispatch(systemMenuToggle(false));
                                    localStorage.clear();
                                }}
                                to="/login"
                                className="dropdown-item"
                                >
                                {t("menu.logout")}
                            </NavLink>
                        </li>
                    </DropdownMenu>
                </DropdownItem>
            </Dropdown>          
        </Content>
    </Container>
}

export default Header;